import {
  DocumentTreeRes,
  GetDocCoordinatesRes,
  GetDocTagsRes,
  SearchDocumentsReq,
  SearchDocumentsRes,
  SearchDocumentsTreeReq,
  SearchTagReq,
  SearchTagRes,
} from 'interfaces/documents';
import axios from 'services/axios';

import { handleAxiosResponse } from './apiUtils';
import { GO_API_PREFIX } from './entities';

export const getDocuments = (params: SearchDocumentsReq) =>
  handleAxiosResponse<SearchDocumentsRes>(
    axios.post(`${GO_API_PREFIX}/doc-api/documents`, params)
  );

export const searchDocumentsTree = (params: SearchDocumentsTreeReq) =>
  handleAxiosResponse<DocumentTreeRes>(
    axios.post(`${GO_API_PREFIX}/doc-api/search`, params)
  );

export const getDocumentTags = (docID: number, category: string) =>
  handleAxiosResponse<GetDocTagsRes>(
    axios.get(`${GO_API_PREFIX}/doc-api/document/${docID}/tags`, {
      params: { category },
    })
  );

export const getTags = (params: SearchTagReq) =>
  handleAxiosResponse<SearchTagRes>(
    axios.post(`${GO_API_PREFIX}/doc-api/tags`, params)
  );

export const getDocumentInPdf = (docId: number, returnRaw = false) =>
  axios.get(`${GO_API_PREFIX}/doc-api/document/${docId}/pdf`, {
    responseType: 'blob',
    params: {
      returnRaw: returnRaw,
    },
  });

export const getDocumentCoordinates = (docId: number) =>
  handleAxiosResponse<GetDocCoordinatesRes>(
    axios.get(`${GO_API_PREFIX}/doc-api/document/${docId}/coordinates`)
  );
